import React from "react";
import { getStories } from "../../api";
import axios from "axios";
import severUrl from "../../api";

class CV extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            stories: []
        };
    }

    componentDidMount() {
        var bodyFormData = new FormData();
        bodyFormData.append("topic_id", 3);
        axios.post(severUrl + "blog/post/story/", bodyFormData).then((response) => {
            this.setState({ stories: response.data })
            // console.log(response)
        })
    }

    render() {
        return (
            <>
                <p style={{fontWeight:"bold"}}>CV (Computer Vision)</p>
                <p className="simple-text-md">Computer vision is a field of artificial intelligence (AI) that enables computers and systems to derive meaningful information from digital images, videos and other visual inputs — and take actions or make recommendations based on that information. If AI enables computers to think, computer vision enables them to see, observe and understand</p>
                <p className="simple-text-md">The topics related to CV task</p>
                <ul style={{display:"list-item", content: "• ", listStyleType:"circle"}}>
                    <li>Optical Character Recognition</li>
                    <li>Image classification</li>
                    <li>Image retreaval</li>
                </ul>
                {
                    this.state.stories.map((item, i) => {
                        return (
                            <p>
                                <a
                                    style={
                                        {
                                            fontSize: "22px",
                                            fontWeight: "0.4"
                                        }
                                    }
                                    href={`/${item.slug}`}>{item.title}</a>
                            </p>
                        );
                    })
                }
            </>
        );
    }
}

export default CV;
